import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const FALLBACK = {
  maintenanceMode: false,
  maintenanceMessage: '',
};

export async function fetchMaintenanceState(timeoutMs = 2000) {
  const remoteRead = getDoc(doc(db, 'config', 'featureFlags'))
    .then((snap) => {
      if (!snap.exists()) return FALLBACK;
      const data = snap.data();
      return {
        maintenanceMode: Boolean(data.maintenanceMode),
        maintenanceMessage: String(data.maintenanceMessage || ''),
      };
    })
    .catch(() => FALLBACK);

  const timeout = new Promise((resolve) => {
    setTimeout(() => resolve(FALLBACK), timeoutMs);
  });

  return Promise.race([remoteRead, timeout]);
}
